/**
 * Usonian CSS > Elements > Link
 */

import { css } from 'styled-components';
import { colors } from 'shared/styles/settings';

export default css`
  a {
    color: ${colors.baseColorAccent};
    text-decoration: none;
  }

  a:hover {
    text-decoration: none !important;
  }
`;
